export default __webpack_public_path__ + "locales/fr/DeleteProfileEverDialog.json?hash=d8dda127881306fe24ffad4ca88531dc";